import Base from "../../../base";
import RoleListLayout from "../layout";

class RoleList extends Base
{
   render() {
       return (
           <RoleListLayout
                btnShow={true}
                oprationShow={true}
           />
       );
   }
}

export default RoleList;
